"use client";

import { useEffect } from "react";
import { track } from "./tracking";

type TrackOnArrivalProps = {
  event: string;
  props?: Record<string, string>;
  /**
   * Paramètre d'adresse à retirer une fois l'événement compté (ex. `envoi`
   * de `/contact/?envoi=ok`) : un rechargement ou un retour sur la page ne le
   * compte pas une seconde fois.
   */
  clearParam?: string;
};

/**
 * Compte un événement à l'arrivée sur une page (03/10/2026). Sert à la page
 * contact : son formulaire HTML classique revient sur `/contact/?envoi=ok`
 * après un envoi réussi, et c'est là qu'on compte `generate_lead`. Rien ne
 * part sans accord du visiteur (`track`).
 */
export function TrackOnArrival({ event, props, clearParam }: TrackOnArrivalProps) {
  const payload = JSON.stringify(props ?? {});
  useEffect(() => {
    track(event, JSON.parse(payload) as Record<string, string>);
    if (!clearParam) return;
    const url = new URL(window.location.href);
    if (!url.searchParams.has(clearParam)) return;
    url.searchParams.delete(clearParam);
    // `history.state` gardé : le routeur de Next y range son état.
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  }, [event, payload, clearParam]);
  return null;
}
